import {
    NavigationState
} from "@/shared/types";
import { PartnerHome } from "@/employer/route-names";
import { defineStore } from "pinia";
import _ from "lodash";

export const initialState: NavigationState = {
    mobileMenuVisible: false,
    lastPartnerPortalTab: PartnerHome
};

export const useNavigationStore = defineStore("navigationStore", {
    state: (): NavigationState => (_.cloneDeep(initialState)),
    actions: {
        toggleMobileMenu () {
            this.mobileMenuVisible = !this.mobileMenuVisible;
        },
        closeMobileMenu () {
            this.mobileMenuVisible = false;
        },
        setLastPartnerPortalTab (value) {
            this.lastPartnerPortalTab = value;
        }
    }
});